var map = {
	"./InfoImg.png": [
		64,
		7,
		149
	],
	"./InfoImg.webp": [
		65,
		7,
		30
	],
	"./Slide2.png": [
		66,
		7,
		150
	],
	"./awards.png": [
		67,
		7,
		151
	],
	"./awards.webp": [
		68,
		7,
		31
	],
	"./bii/ecommerce_01.png": [
		69,
		7,
		152
	],
	"./bii/ecommerce_01.webp": [
		70,
		7,
		32
	],
	"./bii/ecommerce_02.png": [
		71,
		7,
		153
	],
	"./bii/ecommerce_02.webp": [
		72,
		7,
		33
	],
	"./bii/ecommerce_03.png": [
		73,
		7,
		154
	],
	"./bii/ecommerce_03.webp": [
		74,
		7,
		34
	],
	"./bii/ecommerce_11.png": [
		75,
		7,
		155
	],
	"./bii/ecommerce_11.webp": [
		76,
		7,
		35
	],
	"./bii/ecommerce_12.png": [
		77,
		7,
		156
	],
	"./bii/ecommerce_12.webp": [
		78,
		7,
		36
	],
	"./bii/ecommerce_13.png": [
		79,
		7,
		157
	],
	"./bii/ecommerce_13.webp": [
		80,
		7,
		37
	],
	"./bii/ecommerce_14.png": [
		81,
		7,
		158
	],
	"./bii/ecommerce_14.webp": [
		82,
		7,
		38
	],
	"./bii/ecommerce_15.png": [
		83,
		7,
		159
	],
	"./bii/ecommerce_15.webp": [
		84,
		7,
		39
	],
	"./bii/ecommerce_16.png": [
		85,
		7,
		160
	],
	"./bii/ecommerce_16.webp": [
		86,
		7,
		40
	],
	"./bii/ecommerce_17.png": [
		87,
		7,
		161
	],
	"./bii/ecommerce_17.webp": [
		88,
		7,
		41
	],
	"./bii/ecommerce_18.png": [
		89,
		7,
		162
	],
	"./bii/ecommerce_18.webp": [
		90,
		7,
		42
	],
	"./bii/ecommerce_19.png": [
		91,
		7,
		163
	],
	"./bii/ecommerce_19.webp": [
		92,
		7,
		43
	],
	"./bii/ecommerce_20.png": [
		93,
		7,
		164
	],
	"./bii/ecommerce_20.webp": [
		94,
		7,
		44
	],
	"./bii/ecommerce_21.png": [
		95,
		7,
		165
	],
	"./bii/ecommerce_21.webp": [
		96,
		7,
		45
	],
	"./bii/ecommerce_22.png": [
		97,
		7,
		166
	],
	"./bii/ecommerce_22.webp": [
		98,
		7,
		46
	],
	"./bii/ecommerce_23.png": [
		99,
		7,
		167
	],
	"./bii/ecommerce_23.webp": [
		100,
		7,
		47
	],
	"./bii/ecommerce_25.png": [
		101,
		7,
		168
	],
	"./bii/ecommerce_25.webp": [
		102,
		7,
		48
	],
	"./bii/ecommerce_31.png": [
		103,
		7,
		169
	],
	"./bii/ecommerce_31.webp": [
		104,
		7,
		49
	],
	"./bii/ecommerce_32.png": [
		105,
		7,
		170
	],
	"./bii/ecommerce_32.webp": [
		106,
		7,
		50
	],
	"./bii/ecommerce_34.png": [
		107,
		7,
		171
	],
	"./bii/ecommerce_34.webp": [
		108,
		7,
		51
	],
	"./dm/default_01.png": [
		109,
		7,
		172
	],
	"./dm/default_01.webp": [
		110,
		7,
		52
	],
	"./dm/default_02.png": [
		111,
		7,
		173
	],
	"./dm/default_02.webp": [
		112,
		7,
		53
	],
	"./dm/default_03.png": [
		113,
		7,
		174
	],
	"./dm/default_03.webp": [
		114,
		7,
		54
	],
	"./dm/default_04.png": [
		115,
		7,
		175
	],
	"./dm/default_04.webp": [
		116,
		7,
		55
	],
	"./dm/default_05.png": [
		117,
		7,
		176
	],
	"./dm/default_05.webp": [
		118,
		7,
		56
	],
	"./dm/default_06.png": [
		119,
		7,
		177
	],
	"./dm/default_06.webp": [
		120,
		7,
		57
	],
	"./dm/default_07.png": [
		121,
		7,
		178
	],
	"./dm/default_07.webp": [
		122,
		7,
		58
	],
	"./dm/default_08.png": [
		123,
		7,
		179
	],
	"./dm/default_08.webp": [
		124,
		7,
		59
	],
	"./dm/default_09.png": [
		125,
		7,
		180
	],
	"./dm/default_09.webp": [
		126,
		7,
		60
	],
	"./dm/default_10.png": [
		127,
		7,
		181
	],
	"./dm/default_10.webp": [
		128,
		7,
		61
	],
	"./dm/default_11.png": [
		129,
		7,
		182
	],
	"./dm/default_11.webp": [
		130,
		7,
		62
	],
	"./dm/default_12.png": [
		131,
		7,
		183
	],
	"./dm/default_12.webp": [
		132,
		7,
		63
	],
	"./dm/default_13.png": [
		133,
		7,
		184
	],
	"./dm/default_13.webp": [
		134,
		7,
		64
	],
	"./dm/default_14.png": [
		135,
		7,
		185
	],
	"./dm/default_14.webp": [
		136,
		7,
		65
	],
	"./dm/default_15.png": [
		137,
		7,
		186
	],
	"./dm/default_15.webp": [
		138,
		7,
		66
	],
	"./dm/default_16.png": [
		139,
		7,
		187
	],
	"./dm/default_16.webp": [
		140,
		7,
		67
	],
	"./dm/default_17.png": [
		141,
		7,
		188
	],
	"./dm/default_17.webp": [
		142,
		7,
		68
	],
	"./dm/default_18.png": [
		143,
		7,
		189
	],
	"./dm/default_18.webp": [
		144,
		7,
		69
	],
	"./dm/default_19.png": [
		145,
		7,
		190
	],
	"./dm/default_19.webp": [
		146,
		7,
		70
	],
	"./dm/default_20.png": [
		147,
		7,
		191
	],
	"./dm/default_20.webp": [
		148,
		7,
		71
	],
	"./fonts/OpenSansCondensed-Light.ttf": [
		149,
		7,
		72
	],
	"./gelato.png": [
		150,
		7,
		192
	],
	"./gelato.webp": [
		151,
		7,
		73
	],
	"./ii/16-min.png": [
		152,
		7,
		193
	],
	"./ii/16-min.webp": [
		153,
		7,
		74
	],
	"./ii/17-min.png": [
		154,
		7,
		194
	],
	"./ii/17-min.webp": [
		155,
		7,
		75
	],
	"./ii/25-min.png": [
		156,
		7,
		195
	],
	"./ii/25-min.webp": [
		157,
		7,
		76
	],
	"./ii/3-min.png": [
		158,
		7,
		196
	],
	"./ii/3-min.webp": [
		159,
		7,
		77
	],
	"./ii/37-min.png": [
		160,
		7,
		197
	],
	"./ii/37-min.webp": [
		161,
		7,
		78
	],
	"./ii/39-min.png": [
		162,
		7,
		198
	],
	"./ii/39-min.webp": [
		163,
		7,
		79
	],
	"./ii/45-min.png": [
		164,
		7,
		199
	],
	"./ii/45-min.webp": [
		165,
		7,
		80
	],
	"./ii/46-min.png": [
		166,
		7,
		200
	],
	"./ii/46-min.webp": [
		167,
		7,
		81
	],
	"./ii/48-min.png": [
		168,
		7,
		201
	],
	"./ii/48-min.webp": [
		169,
		7,
		82
	],
	"./ii/49-min.png": [
		170,
		7,
		202
	],
	"./ii/49-min.webp": [
		171,
		7,
		83
	],
	"./ii/50-min.png": [
		172,
		7,
		203
	],
	"./ii/50-min.webp": [
		173,
		7,
		84
	],
	"./ii/56-min.png": [
		174,
		7,
		204
	],
	"./ii/56-min.webp": [
		175,
		7,
		85
	],
	"./ii/57-min.png": [
		176,
		7,
		205
	],
	"./ii/57-min.webp": [
		177,
		7,
		86
	],
	"./ii/58-min.png": [
		178,
		7,
		206
	],
	"./ii/58-min.webp": [
		179,
		7,
		87
	],
	"./ii/59-min.png": [
		180,
		7,
		207
	],
	"./ii/59-min.webp": [
		181,
		7,
		88
	],
	"./ii/6-min.png": [
		182,
		7,
		208
	],
	"./ii/6-min.webp": [
		183,
		7,
		89
	],
	"./ii/60-min.png": [
		184,
		7,
		209
	],
	"./ii/60-min.webp": [
		185,
		7,
		90
	],
	"./ii/61-min.png": [
		186,
		7,
		210
	],
	"./ii/61-min.webp": [
		187,
		7,
		91
	],
	"./ii/62-min.png": [
		188,
		7,
		211
	],
	"./ii/62-min.webp": [
		189,
		7,
		92
	],
	"./ii/63-min.png": [
		190,
		7,
		212
	],
	"./ii/63-min.webp": [
		191,
		7,
		93
	],
	"./ii/64-min.png": [
		192,
		7,
		213
	],
	"./ii/64-min.webp": [
		193,
		7,
		94
	],
	"./ii/65-min.png": [
		194,
		7,
		214
	],
	"./ii/65-min.webp": [
		195,
		7,
		95
	],
	"./ii/66-min.png": [
		196,
		7,
		215
	],
	"./ii/66-min.webp": [
		197,
		7,
		96
	],
	"./ii/67-min.png": [
		198,
		7,
		216
	],
	"./ii/67-min.webp": [
		199,
		7,
		97
	],
	"./ii/68-min.png": [
		200,
		7,
		217
	],
	"./ii/68-min.webp": [
		201,
		7,
		98
	],
	"./ii/69-min.png": [
		202,
		7,
		218
	],
	"./ii/69-min.webp": [
		203,
		7,
		99
	],
	"./ii/7-min.png": [
		204,
		7,
		219
	],
	"./ii/7-min.webp": [
		205,
		7,
		100
	],
	"./ii/70-min.png": [
		206,
		7,
		220
	],
	"./ii/70-min.webp": [
		207,
		7,
		101
	],
	"./ii/71-min.png": [
		208,
		7,
		221
	],
	"./ii/71-min.webp": [
		209,
		7,
		102
	],
	"./ii/72-min.png": [
		210,
		7,
		222
	],
	"./ii/72-min.webp": [
		211,
		7,
		103
	],
	"./ii/73-min.png": [
		212,
		7,
		223
	],
	"./ii/73-min.webp": [
		213,
		7,
		104
	],
	"./ii/74-min.png": [
		214,
		7,
		224
	],
	"./ii/74-min.webp": [
		215,
		7,
		105
	],
	"./ii/75-min.png": [
		216,
		7,
		225
	],
	"./ii/75-min.webp": [
		217,
		7,
		106
	],
	"./ii/76-min.png": [
		218,
		7,
		226
	],
	"./ii/76-min.webp": [
		219,
		7,
		107
	],
	"./ii/9-min.png": [
		220,
		7,
		227
	],
	"./ii/9-min.webp": [
		221,
		7,
		108
	],
	"./logo.png": [
		222,
		7,
		228
	],
	"./logo.webp": [
		223,
		7,
		109
	],
	"./partners/Burber.png": [
		224,
		7,
		229
	],
	"./partners/Burber.webp": [
		225,
		7,
		110
	],
	"./partners/Cosmopolit.png": [
		226,
		7,
		230
	],
	"./partners/Cosmopolit.webp": [
		227,
		7,
		111
	],
	"./partners/Eshak.png": [
		228,
		7,
		231
	],
	"./partners/Eshak.webp": [
		229,
		7,
		112
	],
	"./partners/GrandAdmiral.png": [
		230,
		7,
		232
	],
	"./partners/GrandAdmiral.webp": [
		231,
		7,
		113
	],
	"./partners/Hilton.png": [
		232,
		7,
		233
	],
	"./partners/Hilton.webp": [
		233,
		7,
		114
	],
	"./partners/KofeHauz.png": [
		234,
		7,
		234
	],
	"./partners/KofeHauz.webp": [
		235,
		7,
		115
	],
	"./partners/RadissonBlu.png": [
		236,
		7,
		235
	],
	"./partners/RadissonBlu.webp": [
		237,
		7,
		116
	],
	"./partners/barsuk.png": [
		238,
		7,
		236
	],
	"./partners/barsuk.webp": [
		239,
		7,
		117
	],
	"./partners/buddha.png": [
		240,
		7,
		237
	],
	"./partners/buddha.webp": [
		241,
		7,
		118
	],
	"./partners/felini.png": [
		242,
		7,
		238
	],
	"./partners/felini.webp": [
		243,
		7,
		119
	],
	"./partners/hyatt.png": [
		244,
		7,
		239
	],
	"./partners/hyatt.webp": [
		245,
		7,
		120
	],
	"./partners/il-molino.png": [
		246,
		7,
		240
	],
	"./partners/il-molino.webp": [
		247,
		7,
		121
	],
	"./partners/kanapa.png": [
		248,
		7,
		241
	],
	"./partners/kanapa.webp": [
		249,
		7,
		122
	],
	"./partners/osteriapantagruel.png": [
		250,
		7,
		242
	],
	"./partners/osteriapantagruel.webp": [
		251,
		7,
		123
	],
	"./partners/partnersSlide_ru": [
		30,
		3,
		4
	],
	"./partners/partnersSlide_ru.json": [
		30,
		3,
		4
	],
	"./partners/partnersSlide_ua": [
		31,
		3,
		5
	],
	"./partners/partnersSlide_ua.json": [
		31,
		3,
		5
	],
	"./partners/partnersSlide_uk": [
		32,
		3,
		6
	],
	"./partners/partnersSlide_uk.json": [
		32,
		3,
		6
	],
	"./partners/rishelie.png": [
		252,
		7,
		243
	],
	"./partners/rishelie.webp": [
		253,
		7,
		124
	],
	"./partners/shoti.png": [
		254,
		7,
		244
	],
	"./partners/shoti.webp": [
		255,
		7,
		125
	],
	"./partners/spaghetti.png": [
		256,
		7,
		245
	],
	"./partners/spaghetti.webp": [
		257,
		7,
		126
	],
	"./partners/sushiya.png": [
		258,
		7,
		246
	],
	"./partners/sushiya.webp": [
		259,
		7,
		127
	],
	"./partners/tequila.png": [
		260,
		7,
		247
	],
	"./partners/tequila.webp": [
		261,
		7,
		128
	],
	"./partners/vicini.png": [
		262,
		7,
		248
	],
	"./partners/vicini.webp": [
		263,
		7,
		129
	],
	"./partners/НellowSea.png": [
		264,
		7,
		249
	],
	"./partners/НellowSea.webp": [
		265,
		7,
		130
	],
	"./products/products_ru": [
		27,
		3,
		0
	],
	"./products/products_ru.json": [
		27,
		3,
		0
	],
	"./products/products_ua": [
		28,
		3,
		1
	],
	"./products/products_ua.json": [
		28,
		3,
		1
	],
	"./products/products_uk": [
		29,
		3,
		2
	],
	"./products/products_uk.json": [
		29,
		3,
		2
	],
	"./ru.png": [
		266,
		7,
		250
	],
	"./ru.webp": [
		267,
		7,
		131
	],
	"./slide1.png": [
		268,
		7,
		251
	],
	"./slide1.webp": [
		269,
		7,
		132
	],
	"./slide2.webp": [
		270,
		7,
		133
	],
	"./slide3.png": [
		271,
		7,
		252
	],
	"./slide3.webp": [
		272,
		7,
		134
	],
	"./slideImage/Slide2.png": [
		273,
		7,
		253
	],
	"./slideImage/Slide2.webp": [
		274,
		7,
		135
	],
	"./slideImage/Slide4.png": [
		275,
		7,
		254
	],
	"./slideImage/Slide4.webp": [
		276,
		7,
		136
	],
	"./slides/HomePageSlide_ru": [
		33,
		3,
		7
	],
	"./slides/HomePageSlide_ru.json": [
		33,
		3,
		7
	],
	"./slides/HomePageSlide_ua": [
		34,
		3,
		8
	],
	"./slides/HomePageSlide_ua.json": [
		34,
		3,
		8
	],
	"./slides/HomePageSlide_uk": [
		35,
		3,
		9
	],
	"./slides/HomePageSlide_uk.json": [
		35,
		3,
		9
	],
	"./social/hollow-cut-facebook.svg": [
		16,
		7
	],
	"./social/hollow-cut-google.svg": [
		277,
		7,
		137
	],
	"./social/hollow-cut-twitter.svg": [
		278,
		7,
		138
	],
	"./social/hollow-cut-youtube.svg": [
		17,
		7
	],
	"./text/aboutUsText_ru": [
		36,
		3,
		10
	],
	"./text/aboutUsText_ru.json": [
		36,
		3,
		10
	],
	"./text/aboutUsText_ua": [
		37,
		3,
		11
	],
	"./text/aboutUsText_ua.json": [
		37,
		3,
		11
	],
	"./text/aboutUsText_uk": [
		38,
		3,
		12
	],
	"./text/aboutUsText_uk.json": [
		38,
		3,
		12
	],
	"./text/contactsText_ru": [
		39,
		3,
		13
	],
	"./text/contactsText_ru.json": [
		39,
		3,
		13
	],
	"./text/contactsText_ua": [
		40,
		3,
		14
	],
	"./text/contactsText_ua.json": [
		40,
		3,
		14
	],
	"./text/contactsText_uk": [
		41,
		3,
		15
	],
	"./text/contactsText_uk.json": [
		41,
		3,
		15
	],
	"./text/homeText_ru": [
		42,
		3,
		16
	],
	"./text/homeText_ru.json": [
		42,
		3,
		16
	],
	"./text/homeText_ua": [
		43,
		3,
		17
	],
	"./text/homeText_ua.json": [
		43,
		3,
		17
	],
	"./text/homeText_uk": [
		44,
		3,
		18
	],
	"./text/homeText_uk.json": [
		44,
		3,
		18
	],
	"./text/partnersText_ru": [
		45,
		3,
		19
	],
	"./text/partnersText_ru.json": [
		45,
		3,
		19
	],
	"./text/partnersText_ua": [
		46,
		3,
		20
	],
	"./text/partnersText_ua.json": [
		46,
		3,
		20
	],
	"./text/partnersText_uk": [
		47,
		3,
		21
	],
	"./text/partnersText_uk.json": [
		47,
		3,
		21
	],
	"./ua.png": [
		279,
		7,
		255
	],
	"./ua.webp": [
		280,
		7,
		139
	],
	"./uk.png": [
		281,
		7,
		256
	],
	"./uk.webp": [
		282,
		7,
		140
	],
	"./vp/1.png": [
		283,
		7,
		257
	],
	"./vp/1.webp": [
		284,
		7,
		141
	],
	"./vp/2.png": [
		285,
		7,
		258
	],
	"./vp/2.webp": [
		286,
		7,
		142
	],
	"./vp/3.png": [
		287,
		7,
		259
	],
	"./vp/3.webp": [
		288,
		7,
		143
	],
	"./vp/4.png": [
		289,
		7,
		260
	],
	"./vp/4.webp": [
		290,
		7,
		144
	],
	"./vp/5.png": [
		291,
		7,
		261
	],
	"./vp/5.webp": [
		292,
		7,
		145
	],
	"./vp/6.png": [
		293,
		7,
		262
	],
	"./vp/6.webp": [
		294,
		7,
		146
	],
	"./vp/7.png": [
		295,
		7,
		263
	],
	"./vp/7.webp": [
		296,
		7,
		147
	],
	"./vp/8.png": [
		297,
		7,
		264
	],
	"./vp/8.webp": [
		298,
		7,
		148
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 26;
module.exports = webpackAsyncContext;